<template>
  <div class="content_container">
    <div class="module">
      <div class="module_left">
        <div
          class="main_new"
          v-if="contentData.workActivityList.length > 0"
          @click="jumping('工作动态', contentData.workActivityList[0].id)"
        >
          <h3 class="new_tit">
            {{ contentData.workActivityList[0].mainTitle }}
          </h3>
          <p
            class="new_con"
            v-html="filterImgTag(contentData.workActivityList[0].content)"
          ></p>
        </div>
        <div class="tab_container">
          <div class="tab_tit">
            <div
              class="tab_tit_item"
              :class="{ active: tabActive === 0 }"
              @click="hadleTabChange(0)"
            >
              工作动态
            </div>
            <div
              class="tab_tit_item"
              :class="{ active: tabActive === 1 }"
              @click="hadleTabChange(1)"
            >
              党群工作
            </div>
            <div
              class="tab_tit_item"
              :class="{ active: tabActive === 2 }"
              @click="hadleTabChange(2)"
            >
              公告信息
            </div>
          </div>
          <div class="tab_con">
            <ul class="tab_con_item two_clos" v-if="tabList.length > 0">
              <li
                v-for="item in tabList"
                :key="item.id"
                @click="tabJumpBefore(item.id)"
              >
                <p class="item_title">
                  {{ item.mainTitle }}
                </p>
                <p>
                  {{ moment(item.publishTime).format("MM-DD") }}
                </p>
              </li>
              <li class="more">
                <p class="item_title"></p>
                <p class="more_text" @click="tabJumpBefore('')">
                  >>更多
                </p>
              </li>
            </ul>
            <div class="no_data" v-else>暂无数据</div>
          </div>
        </div>
      </div>
      <div class="module_right">
        <div class="module_tit">
          通知公告
          <span
            class="more_text"
            v-if="contentData.messeageList.length > 0"
            @click="jumping('通知公告')"
            >>>更多</span
          >
        </div>
        <div class="module_con">
          <ul v-if="contentData.messeageList.length > 0">
            <li
              v-for="item in contentData.messeageList"
              :key="item.id"
              @click="jumping('通知公告', item.id)"
            >
              <p class="item_title">
                {{ item.mainTitle }}
              </p>
              <p>
                {{ moment(item.publishTime).format("MM-DD") }}
              </p>
            </li>
          </ul>
          <div class="no_data" v-else>暂无数据</div>
        </div>
      </div>
    </div>
    <div class="small_banner">
      <img
        class="img_left"
        v-if="contentData.smallLeftBanner.length > 0"
        :src="contentData.smallLeftBanner[0].address"
      />
      <img
        class="img_right"
        v-if="contentData.smallRightBanner.length > 0"
        :src="contentData.smallRightBanner[0].address"
      />
    </div>
    <div class="module">
      <div class="module_left">
        <div class="module_tit">
          新闻快讯
          <span
            class="more_text"
            v-if="contentData.newsList.length > 0"
            @click="jumping('新闻快讯')"
            >>>更多</span
          >
        </div>
        <div class="module_con module_con_row">
          <div class="swiper_container" v-if="contentData.newsList.length > 0">
            <swiper :options="swiperOptions" class="swiper">
              <swiper-slide
                class="swiper_item"
                v-for="item in getFiveList(contentData.newsList)"
                :key="item.id"
                @click="jumping('新闻快讯', item.id)"
              >
                <img class="swiper_img" :src="item.picAddress" />
                <p class="title">
                  {{ item.mainTitle }}
                </p>
                <p class="time">
                  {{ moment(item.publishTime).format("YYYY-MM-DD") }}
                </p>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination"></div>
          </div>
          <ul v-if="contentData.newsList.length > 0">
            <li
              v-for="item in contentData.newsList"
              :key="item.id"
              @click="jumping('新闻快讯', item.id)"
            >
              <p class="item_title">
                {{ item.mainTitle }}
              </p>
              <p>
                {{ moment(item.publishTime).format("MM-DD") }}
              </p>
            </li>
          </ul>
          <div class="no_data" v-else>暂无数据</div>
        </div>
      </div>
      <div class="module_right">
        <div class="module_tit">
          下载专区
          <span
            class="more_text"
            v-if="contentData.uploadList.length > 0"
            @click="jumping('资料下载')"
            >>>更多</span
          >
        </div>
        <div class="module_con">
          <ul v-if="contentData.uploadList.length > 0">
            <li
              v-for="item in contentData.uploadList"
              :key="item.id"
              @click="jumping('资料下载', item.id)"
            >
              <p class="item_title">
                {{ item.fileName }}
              </p>
              <p @click.stop="downFile(item.fileAddress)">
                <i class="iconfont icon-xiazai"></i>
              </p>
            </li>
          </ul>
          <div class="no_data" v-else>暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/swiper-bundle.min.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SwiperCore, { Autoplay, Pagination } from "swiper";
SwiperCore.use([Autoplay, Pagination]);

import moment from "moment";
let vm = null;
export default {
  props: {
    contentData: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
      moment,
      // tab切换
      tabActive: 0,
      tabList: [],

      swiperOptions: {
        slidesPerView: 1,
        grabCursor: true,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        on: {
          click: function() {
            vm.handleClickSwiper(this.realIndex);
          },
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    vm = this;
    this.hadleTabChange(0);
  },
  methods: {
    // 文件下载
    downFile(fileUrl) {
      window.open(fileUrl);
    },
    // 点击新闻快讯轮播
    handleClickSwiper(idx) {
      let id = this.contentData.newsList[idx].id;
      this.jumping("新闻快讯", id);
    },
    // 新闻快讯数据处理
    getFiveList(list) {
      let newList = JSON.parse(JSON.stringify(list));
      if (newList.length > 5) {
        newList.splice(0, 5);
      }
      return newList;
    },
    // 跳转
    jumping(current, id) {
      let path;
      if (
        current === "工作动态" ||
        current === "公告信息" ||
        current === "通知公告" ||
        current === "新闻快讯"
      ) {
        path = id ? "/newsDetail" : "/news";
      } else if (current === "党群工作") {
        path = id ? "/workDetail" : "/work";
      } else if (current === "通知公告") {
        path = id ? "/workDetail" : "/work";
      } else if (current === "资料下载") {
        path = id ? "/guideDetail" : "/guide";
      }
      this.$router.push({
        path,
        query: {
          id,
          current,
        },
      });
    },
    // tab数据跳转详情页之前处理
    tabJumpBefore(id) {
      let idx = this.tabActive;
      let current = "工作动态";
      if (idx === 1) {
        current = "党群工作";
      } else if (idx === 2) {
        current = "公告信息";
      }
      if (id) {
        this.jumping(current, id);
      } else {
        this.jumping(current, "");
      }
    },
    // tab切换
    hadleTabChange(idx) {
      let key = "workActivityList";
      if (idx === 1) {
        key = "partyList";
      } else if (idx === 2) {
        key = "noticeList";
      }
      this.tabActive = idx;
      this.tabList = this.contentData && this.contentData[key];
    },
    // 过滤掉html标签
    filterImgTag(html) {
      let res = html
        .replace(/(<([^>]+)>)/gi, "")
        .replace(/[\r\n]/g, "")
        .replace(/\s+/g, "");
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.content_container {
  width: 1110px;
  margin: 0 auto;
  padding-top: 20px;
  .module {
    margin-top: 20px;
    display: flex;
    .module_left {
      width: 735px;
      padding-right: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .main_new {
        color: #a13838;
        border-bottom: 1px #e6e6e6 solid;
        cursor: pointer;
        .new_tit,
        .new_con {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .new_tit {
          font-weight: bold;
          font-size: 30px;
        }
        .new_con {
          margin-top: 10px;
          padding-bottom: 20px;
          font-size: 16px;
        }
      }
      .tab_container {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .tab_tit {
          display: flex;
          .tab_tit_item {
            flex: 1;
            height: 42px;
            line-height: 42px;
            text-align: center;
            border: 1px #e6e6e6 solid;
            margin-right: 12px;
            color: #a13838;
            font-weight: bold;
            font-size: 16px;
            box-sizing: border-box;
            cursor: pointer;
            &.active {
              color: #fff;
              background-color: #a13838;
              border: none;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .tab_con {
          flex: 1;
          padding: 20px 0 0;
          box-sizing: border-box;
          .tab_con_item {
            display: flex;
            flex-wrap: wrap;
          }
        }
      }
    }
    .module_right {
      flex: 1;
      border-left: 1px #e6e6e6 solid;
      padding-left: 20px;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
    }
    // 新闻快讯模块
    .module_con_row {
      display: flex;
      .swiper_container {
        position: relative;
        margin: 20px 20px 0 0;
        .swiper {
          width: 355px;
          .swiper_item {
            .swiper_img {
              width: 355px;
              height: 220px;
              object-fit: cover;
            }
            p {
              color: #666;
              padding-left: 15px;
              &.title {
                position: relative;
                margin-top: 10px;
                font-size: 16px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &::before {
                  content: "";
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 4px;
                  height: 4px;
                  border-radius: 4px;
                  background-color: #cecdcd;
                }
              }
              &.time {
                margin-top: 8px;
                color: #999;
              }
            }
          }
        }
        .swiper-pagination {
          position: absolute;
          top: 190px;
          right: 10px;
          & ::v-deep .swiper-pagination-bullet {
            width: 20px;
            height: 20px;
            border: 1px #fff solid;
            border-radius: 2px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.4);
            opacity: 1;
            margin-right: 6px;
            &:last-child {
              margin-right: 0;
            }
            &.swiper-pagination-bullet-active {
              background-color: rgba(161, 56, 56, 0.8);
            }
          }
        }
      }
    }
    // 公共样式
    .module_tit {
      padding: 20px 0 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px #e6e6e6 solid;
      box-sizing: border-box;
      color: #a13838;
      font-weight: bold;
      font-size: 16px;
      position: relative;
      .more_text {
        cursor: pointer;
        font-size: 12px;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: -1px;
        left: 0;
        height: 2px;
        width: 68px;
        background-color: #a13838;
      }
    }
    .module_con {
      flex: 1;
      min-height: 300px;
    }
    ul {
      flex: 1;
      overflow: hidden;
      li {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 15px 0 16px;
        position: relative;
        color: #666;
        cursor: pointer;
        &::after {
          content: "";
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
          height: 0px;
          border-bottom: 1px #e6e6e6 dashed;
        }
        .item_title {
          flex: 1;
          padding-right: 20px;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 15px;
          box-sizing: border-box;
          position: relative;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            border-radius: 4px;
            background-color: #cecdcd;
          }
        }
        &:hover {
          color: #a13838;
          .item_title {
            &::before {
              background-color: #a13838;
            }
          }
        }
      }
      &.two_clos {
        li {
          width: 50%;
          border-bottom: none;
          &::after {
            width: calc(100% - 20px);
          }
          &:nth-child(odd) {
            padding-right: 20px;
            border-right: 1px #e6e6e6 solid;
            &::before,
            &::after {
              left: 0px;
            }
          }
          &:nth-child(even) {
            padding-left: 20px;
            &::before {
              left: 20px;
            }
            &::after {
              left: 20px;
            }
          }
          &.more {
            color: #a13838;
            font-size: 12px;
            cursor: inherit;
            &::before,
            &::after {
              display: none;
            }
            .more_text {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .small_banner {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .img_left {
      width: 735px;
      height: 66px;
      object-fit: cover;
    }
    .img_right {
      width: 374px;
      height: 66px;
      object-fit: cover;
    }
  }
}
</style>
